<template>
  <b-modal
    ref="modal"
    title="Recebimentos"
    header-class="border-bottom-0"
    size="lg"
    hide-footer
  >
    <b-row>
      <b-col class="mx-2">
        <b-table
          small
          responsive
          borderless
          :items="billPayments"
          :fields="fields"
        >
          <template #cell(payed_at)="data">
            {{ data.item.payed_at | dateBr }}
          </template>
          <template #cell(received_value)="data">
            {{ data.item.received_value | decimal }}
          </template>
          <template #cell(discount)="data">
            {{ data.item.discount | decimal }}
          </template>
          <template #cell(addition)="data">
            {{ data.item.addition | decimal }}
          </template>
          <template #cell(interest)="data">
            {{ data.item.interest | decimal }}
          </template>
          <template #cell(payed_value)="data">
            {{ data.item.payed_value | decimal }}
          </template>
          <template #cell(payment_method)="data">
            <PaymentMethodBadge :paymentMethod="data.item.payment_method" />
          </template>
          <template #cell(action)="data">
            <b-dropdown
              variant="transparent"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v text-muted" />
              </template>
              <b-dropdown-item @click.stop="printReceipt(data.item)">
                <i class="fas fa-print" />
                Imprimir Recibo
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import PaymentMethodBadge from '@/components/account/sections/PaymentMethodBadge.vue';

export default {
  components: { PaymentMethodBadge },
  data: function () {
        return {
      billPayments: [],
      fields: [
        { key: "payed_at", label: "Pago em", class: "text-center" },
        { key: "received_value", label: "Valor", class: "text-center" },
        { key: "discount", label: "Desconto", class: "text-center" },
        { key: "addition", label: "Acréscimo", class: "text-center" },
        { key: "interest", label: "Juros", class: "text-center" },
        { key: "payed_value", label: "Valor Recebido", class: "text-center" },
        {
          key: "payment_method",
          label: "Forma de Pagamento",
          class: "text-center",
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          width: "5%",
        },
      ],
    };
  },

  methods: {
    open(id) {
      axios
        .post("api/billpayment/select", { bill_id: id })
        .then((response) => { 
          this.billPayments = response.data;
          this.$refs.modal.show();
        })
        .catch((error) => {
          this.error = error;
        });
    },
    printReceipt(row) {
      window.open(
        "/contasareceber/imprimir-recibo-parcial/" + row.id,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>